export default __webpack_public_path__ + "static/media/sedan-car-front.53466786.png";